import { render } from "./RelatedProductsComponent.vue?vue&type=template&id=ecc4a7ae"
import script from "./RelatedProductsComponent.vue?vue&type=script&lang=js"
export * from "./RelatedProductsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/staderecord/assets/js/components/RelatedProductsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ecc4a7ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ecc4a7ae', __exports__)) {
    api.reload('ecc4a7ae', __exports__)
  }
  
  module.hot.accept("./RelatedProductsComponent.vue?vue&type=template&id=ecc4a7ae", () => {
    api.rerender('ecc4a7ae', render)
  })

}


export default __exports__